





































































/* eslint-disable max-len */
import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import ChevronIcon from 'mdi-vue/ChevronRight';
import EyeIcon from 'mdi-vue/Eye';
import Loader from '@/components/Loader.vue';
import Select from '@/components/Select.vue';

@Component({
  components: {
    ChevronIcon,
    EyeIcon,
    Loader,
    Select,
  },
})
export default class HomeBox extends Vue {
  @Prop(String) value!: string;
  @Prop(String) box!: string;
  @Prop(String) colors!: string;
  @Prop(String) label!: string;
  @Prop(Boolean) trig!: boolean;
  @Prop(Array) options!: object;
  @Prop(Object) channel: null | LabelValue = null;
  @Prop(Object) selectedChannel: null | LabelValue = null;
  @Prop(String) startDate!: string;
  @Prop(String) endDate!: string;
  @Prop(Boolean) loadingCard!: boolean;

  selected = {
    label: this.label,
    value: '00',
  };

  lastSelected = {
    label: this.label,
    value: '00',
  }

  credit_card_status = [
    { key: '00', value: 'Success' },
    { key: '02', value: 'Failed' },
    { key: '03', value: 'Un-Processed' },
  ]

  loading = true;
  color = '';
  blue = '#22a7f0';
  red = '#e05d6f';
  green = '#01c1c1';
  yellow = '#efad4e';
  purple = 'ffcf07';

  @Watch('selectedChannel')
  changeSelect() {
    if (this.selectedChannel !== null) {
      this.selected = this.selectedChannel;
    }
  }

  @Watch('selected')
  sendValue() {
    console.log(this.selectedChannel);
    if (this.selected !== null) {
      if (this.selectedChannel !== this.selected) {
        this.lastSelected = this.selected;
        this.$emit('selectedBox', this.selected);
      }
    }
  }

  @Watch('loadingCard')
  loadingC() {
    this.loading = this.loadingCard;
  }

  detail() {
    if (this.channel?.value === 'bnism') {
      this.channel.value = 'bni_ipay';
    }
    if (this.channel?.value === 'credit_card') {
      // window.open(`/payment-gateway/transaction-report/${this.channel.value.replace(/_/g, '-')}`);

      this.$router.push(`/payment-gateway/transaction-report/${this.channel.value.replace(/_/g, '-')}?td=${this.startDate},${this.endDate}&ts=${this.credit_card_status.find((e) => e.key === this.selected.value)?.value}`);
    } else if (this.channel?.value === 'permata_va'
      || this.channel?.value === 'bca_va'
      || this.channel?.value === 'bni_va'
      || this.channel?.value === 'bri_va'
      || this.channel?.value === 'danamon_va'
      || this.channel?.value === 'maybank_va'
      || this.channel?.value === 'mandiri_va'
    ) {
      this.$router.push(`/payment-gateway/transaction-report/online-transfer/${this.channel.value.replace(/_/g, '-')}?pd=${this.startDate},${this.endDate}&ts=${this.selected.value}`);
    } else if (this.channel?.value === 'bca_klikpay'
      || this.channel?.value === 'klik_bca'
      || this.channel?.value === 'bca_sakuku'
      || this.channel?.value === 'bni_ipay'
      || this.channel?.value === 'cimb_click'
      || this.channel?.value === 'bri_epay'
      || this.channel?.value === 'permata_net') {
      this.$router.push(`/payment-gateway/transaction-report/internet-banking/${this.channel.value.replace(/_/g, '-')}?pd=${this.startDate},${this.endDate}&ts=${this.selected.value}`);
    } else if (this.channel?.value === 'kredivo'
      || this.channel?.value === 'indodana'
      || this.channel?.value === 'homecredit') {
      this.$router.push(`/payment-gateway/transaction-report/instant-credit/${this.channel.value.replace(/_/g, '-')}?pd=${this.startDate},${this.endDate}&ts=${this.selected.value}`);
    } else if (this.channel?.value === 'shopeepay'
      || this.channel?.value === 'tcash'
      || this.channel?.value === 'mecash'
      || this.channel?.value === 'dana') {
      this.$router.push(`/payment-gateway/transaction-report/e-money/${this.channel.value.replace(/_/g, '-')}?pd=${this.startDate},${this.endDate}&ts=${this.selected.value}`);
    } else if (this.channel?.value === 'easyinvoice') {
      this.$router.push(`/payment-gateway/transaction-report/other/${this.channel.value.replace(/_/g, '-')}?pd=${this.startDate},${this.endDate}&ts=${this.selected.value}`);
    }
  }

  mounted() {
    if (this.colors === 'blue') {
      this.color = this.blue;
    } else if (this.colors === 'red') {
      this.color = this.red;
    } else if (this.colors === 'green') {
      this.color = this.green;
    } else if (this.colors === 'yellow') {
      this.color = this.yellow;
    } else {
      this.color = this.purple;
    }
  }
}
